import React from 'react';
import Select from 'react-select';
import './FilterBar.css';

const FilterBar = ({
  countryOptions,
  categoryOptions,
  onFilterChange,
  onMonthChange,
  searchParams,
  currentView, 
  onViewChange,
}) => {

  const continentOptions = [
    { value: 'North America', label: 'North America' },
    { value: 'Europe', label: 'Europe' },
    { value: 'Asia', label: 'Asia' },
    { value: 'South America', label: 'South America' },
    { value: 'Africa', label: 'Africa' },
    { value: 'Oceania', label: 'Oceania' },
  ];

  const months = [
    { value: 1, label: 'January' }, { value: 2, label: 'February' },
    { value: 3, label: 'March' }, { value: 4, label: 'April' },
    { value: 5, label: 'May' }, { value: 6, label: 'June' },
    { value: 7, label: 'July' }, { value: 8, label: 'August' },
    { value: 9, label: 'September' }, { value: 10, label: 'October' },
    { value: 11, label: 'November' }, { value: 12, label: 'December' }
  ];

  const getSelectedValues = (key, options) => {
    const selected = searchParams.getAll(key);
    return options.filter(option => selected.includes(option.value));
  };

  return (
    <div className="filter-bar-container">
      <div className="filter-select__container month-filter">
        <select 
          className="month-filter-select"
          onChange={onMonthChange} 
          value={searchParams.get('month') || ''}
        >
          <option value="">Filter by Month (All)</option>
          {months.map(month => (
            <option key={month.value} value={month.value}>{month.label}</option>
          ))}
        </select>
      </div>

      <div className="filter-select__container">
        <Select
          instanceId="category-select"
          isMulti
          options={categoryOptions}
          onChange={(selected) => onFilterChange('category', selected)}
          value={getSelectedValues('category', categoryOptions)}
          placeholder="Filter by Category..."
          classNamePrefix="filter-select"
          menuPortalTarget={document.body}
        />
      </div>
      <div className="filter-select__container">
        <Select
          instanceId="continent-select"
          isMulti
          options={continentOptions}
          onChange={(selected) => onFilterChange('continent', selected)}
          value={getSelectedValues('continent', continentOptions)}
          placeholder="Filter by Continent..."
          classNamePrefix="filter-select"
          menuPortalTarget={document.body}
        />
      </div>
      <div className="filter-select__container">
        <Select
          instanceId="country-select"
          isMulti
          options={countryOptions}
          onChange={(selected) => onFilterChange('country', selected)}
          value={getSelectedValues('country', countryOptions)}
          placeholder="Filter by Country..."
          classNamePrefix="filter-select"
          menuPortalTarget={document.body}
        />
      </div>
      
      <div className="view-toggle-container">
        <button 
          className={`view-toggle-button ${currentView === 'calendar' ? 'active' : ''}`} 
          onClick={() => onViewChange('calendar')}
        >
          Calendar
        </button>
        <button 
          className={`view-toggle-button ${currentView === 'map' ? 'active' : ''}`} 
          onClick={() => onViewChange('map')}
        >
          Map
        </button>
      </div>
    </div>
  );
};

export default FilterBar;